import * as React from "react";
import { LinkTargetType } from "../../../services/playground";
import { StyledComponent } from "styled-components";
import { transformAParam } from "utils/browser";
import { TextSpan, transformBox } from "./styles";
interface ViewMoreCardProps {
	link: string;
	text: string;
	isInApp: boolean;
	StyledComponent: StyledComponent<"a", any, { isRollable?: boolean }>;
	isRollable?: boolean;
}

class ViewMoreCard extends React.PureComponent<ViewMoreCardProps> {
	private VMCardBox = transformBox(this.props.StyledComponent);
	render() {
		const { link, isRollable, text, isInApp } = this.props;
		const { VMCardBox } = this;
		const aProps = transformAParam({
			link,
			aTarget: LinkTargetType.Blank,
			isInApp,
		});
		return (
			<VMCardBox {...aProps} isRollable={isRollable}>
				<img
					style={{ width: 32, height: 32 }}
					src={"https://t.rightinthebox.com/tights/litb/fsgocuwjtg80_FjFwuX0r1Lw5Z4nb3BfR2uPt3zVY.png"}
				/>

				<TextSpan>{text || "View More"}</TextSpan>
			</VMCardBox>
		);
	}
}
export default ViewMoreCard;
